import React, { useState, useEffect } from 'react';
import { Icon } from "@iconify/react";
import "../styles/alert.css";

/* This component is used to show feedback messages whenever some action is performed by the user */
const CustomAlert = ({ type, message, autoDismiss = true, timeout = 5000, onClose }) => {

  const [isVisible, setIsVisible] = useState(true);

  // If the user doesn't close the alert, close it automatically after <timeout> ms
  useEffect(() => {
    if (autoDismiss) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, timeout);

      return () => clearTimeout(timer);
    }
  }, [autoDismiss, timeout, onClose]);

  // Define the icon mapping based on the type
  const iconMap = {
    success: <Icon icon="ep:success-filled" width="24" height="24" />,
    warning: <Icon icon="mingcute:alert-fill" width="24" height="24" />,
    error: <Icon icon="ix:error-filled" width="24" height="24" />,
  };

  // Check type and parse icon accordingly
  const icon = iconMap[type];

  // Handle close
  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  // Don't render if not visible
  if (!isVisible) return null;



  return (
    <div className={`custom-alert alert-${type}`}>
      {icon && <div className="alert-icon">{icon}</div>}
      <div className="alert-message">{message}</div>
      <button className="alert-close-btn" onClick={handleClose}>
        &times;
      </button>
    </div>
  );
};

export default CustomAlert;
